import strapi, { mapStrapiData } from '../lib/strapi';
import qs from 'qs';

/**
 * Fetches home page data with deep population for team member photos and all media.
 */
export const getHomePageData = async () => {
  try {
    const query = qs.stringify({
      populate: {
        hero_image: true,
        about_video: true,
        missionvision_image: true,
        stats_image: true,
        brandlogos_images: true,
        sdg_image: true,
        team_members: { populate: 'profile_image' },
        benefits_list: { populate: '*' },
        sdg_list: { populate: '*' },
        stats_list: { populate: '*' }
      }
    });
    
    const response = await strapi.get(`/home-page?${query}`);
    const data = mapStrapiData(response);
    
    if (!data) return null;

    return data;
  } catch (error) {
    console.error('Home Page API Error:', error);
    return null;
  }
};
